module.exports = __webpack_public_path__ + "static/media/logout.bab781e8.svg";